<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="fabricCode"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ reserve: true, highlight: true, range: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @checkbox-range-change="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:displayFabricName="{ row }">
        <TableLabel :value="row.fabricName" />
        <TableLabel :value="row.fabricNameEn" />
        <TableLabel label="NO" :value="row.fabricNo" />
      </template>
      <template v-slot:fabricStatus="{ row }">
        <el-tag
          size="mini"
          :type="
              row.fabricStatus === 'Y'
                ? 'success'
                : row.fabricStatus === 'Q'
                ? 'primary'
                : 'danger'
            "
        >
          {{ row.v_fabricStatus }}
        </el-tag>
      </template>

      <template v-slot:displayWid="{ row }">
        <TableLabel
          :label="$l('table_label_wid') || '门幅'"
          :value="`${row.wid || 0} ${row.widUnit}`"
        />
        <TableLabel
          :label="$l('table_label_fabricWeight') || '克重'"
          :value="`${row.fabricWeight || 0} ${row.fabricWeightUnit}`"
        />
      </template>
      <template v-slot:displayFabricContent="{ row }">
        <TableLabel :value="row.fabricContent" />
        <TableLabel :value="row.fabricContentEn" />
      </template>

      <template v-slot:displayPrice="{ row }">
        <span>
          {{ row.unitPrice }} {{ $l('table_label_unitPriceUnit') || '元' }}/
          {{ row.v_fabricUnit }}
        </span>
      </template>

      <template v-slot:displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import TableLabel from './label.vue'
export default {
  components: { TableLabel },
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { fabricCode, fabricNo } = data
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
        case 'copy':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { fabricCode },
            query: { fabricNo },
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'recovery':
          this.recovery(data)
          break
        case 'printer':
          this.$emit('printer', data)
          break
        default:
          console.error('menuType configuration error:', menuType)
      }
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      const $table = this.$refs.table
      $table.clearCheckboxRow()
      $table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'displayImage']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
    async del({ fabricCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .masterFabric_del({ fabricCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async recovery({ fabricCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_recovery') || '是否要恢复该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .masterFabric_recovery({ fabricCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_recovery_no') || '恢复失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_recovery_ok') || '恢复成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
